<template>
    <div class="mainContentAdmin" id="weblogCategories">
      <b-overlay :show="status" no-wrap fixed z-index="9999">
        <template v-slot:overlay>
          <div class="d-flex align-items-center">
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          </div>
        </template>
      </b-overlay>
      <div class="filters">
        <!-- <b-button variant="primary" @click="showModalFunction">افزودن </b-button> -->
        <b-button variant="warning" @click="getReport()">گزارش </b-button>
      </div> 
       <div v-if="items" class="mainTable">
        <s-table
         @showEditModal="showEditModal" 
         @deleteItem="deleteItem"
         customeFiledCallBack="item"
          v-model="items"
          :settings="settings"
          :headers="headers"
          @callModalFromTable="callModalFromTable"
        />
      </div> 
      <!-- <div v-if="items " class="mainTable">
        <table v-if="items.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th> شماره سفارش</th>
            <th>نام مشتري</th>
            <th>تاريخ ايجاد </th>
            <th></th>
          </tr>
          <tr class="trDetail" v-for="item in items" :key="item.id" >          
            <td>
              {{ item.orderNumber }}
            </td>
            <td>
              {{ item.fullName }}
            </td>
            <td>
              {{ new Date(item.createDate).toLocaleDateString("fa") }}
            </td>        
            <td>
            <td class="handlerSUp" >
              <div class="links">
            <b-button   variant="info" @click="callModalFromTable(item)"
              >مشاهده
            </b-button> 
          </div>
            </td>
            </td>              
          </tr>
        </table>
    </div> -->
      <div v-if="items != null && totalPages > 1">
        <div id="pagination">
          <pagination
            @pageChanged="pageChanged"
            :totalPages="totalPages"
            :currentPage="currentPage"
          />
        </div>
      </div>
              <!-- <s-inputs
          :disabled="disabled"
          @submit="submit"
          :mode="mode"
          :folderRoute="'calibrationLabSurveys'"
          :bigData="bigData"
          :settings="settings"
          :headers="headers"
        /> -->
       <b-modal
        id="surveyModal"
        hide-footer
        ref="surveyModal"
        no-close-on-backdrop
        v-model="showModal"
        @close="resetModal()"
        :title="' مشاهده ' + title"
      >
        <div v-if="itemsQuestion" class="mainTable">
        <table v-if="itemsQuestion.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>سوال</th>
            <th>امتياز (0 تا 20) </th>
            <th>توضيحات</th>
          </tr>
          <tr class="trDetail" v-for="item in itemsQuestion" :key="item.id"  >          
            <td>
              {{ item.title_fa }}
            </td>
            <td>
               {{ item.priority }} 
            </td>
            <td>
                 {{ item.description }}
            </td>             
          </tr>
        </table>
    </div>
      </b-modal>  
    </div>
  </template>
  <script>
  import pagination from "@/components/front/shared/pagination.vue";
  import SInputs from "@/components/admin/shared/sInputs.vue";
  import STable from "@/components/admin/shared/sTable.vue";
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner } from "bootstrap-vue";
  export default {
    mixins: [adminMixin],
    components: {
      SInputs,
      BModal,
      BButton,
      STable,
      BOverlay,
      BSpinner,
      pagination
    },
    data() {
      return {
        headers: [
        {
            style: "col-12",
            show_in_table: false,
           // placeholder: " شماره سفارش را وارد کنید",
            type: "string",
            multiData: false,
            name: "id",
            key: "id"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: " شماره سفارش را وارد کنید",
            type: "string",
            multiData: false,
            name: "شماره سفارش",
            key: "orderNumber"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: " نام و نام خانوادگي را وارد کنید",
            type: "string",
            multiData: false,
            name: "نام و نام خانوادگي",
            key: "fullName"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "تاريخ ايجاد راوارد کنید",
            type: "date",
            multiData: false,
            name: " تاريخ ايجاد",
            key: "createDate"
          },
          {
            style: "col-6",
            show_in_table: true,
            //placeholder: " ايجاد راوارد کنید",
            type: "number",
            multiData: false,
            name: "جمع امتياز",
            key: "sumPriority"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "",
            type: "setting",
            name: "تنظیمات",
            multiData: false,
            key: "",
           // innerRoute: "/admin-panel/product-feature",
           // edit: false,
           // delete: false,
            //editLabel: "مشاهده",
            show:false,
            //edit: true,
            buttonModalTitle: " مشاهده",
             modal: true,
          }
        ],
        pageSize: 10,
        bigData: {
          persian: {},
          english: {},
          both: {}
        },
        title: "نظرسنجي آزمايشگاه كاليبراسيون",
        editedId: null,
        apiRoute: "CalibrationLabSurvey",
        itemsQuestion :null,
        showModal:false,
      };
    },
   
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page;
      } else {
        this.currentPage = 1;
      }
    //  this.loadSettings([{ route: "ProductCategory", field: "name" },{ route: "Brand", field: "title" },{ route: "UnitProduct", field: "title" }]);
  
      //  this.settings['selectListType']=[ {id:'خانوار',label:'خانوار'}, {id:'صنف و صنعت',label:'صنف و صنعت'}]
      this.loadItems(this.currentPage);
      //this.loadItems();
    },
    watch: {
      item(newVal) {
        this.bigData = newVal;
      }
    },
    methods: {
    //   showModalFunction() {
    //     this.showModal = true;
    //     setTimeout(() => {
    //       document
    //         .getElementById("blogModal___BV_modal_content_")
    //         .removeAttribute("tabindex");
    //     });
    //   }
    // },
    getReport() {
      this.$axios
        .get("CalibrationLabSurvey/GetCalibrationLabSurveyReports", {
          headers: {
            "Content-Disposition": "attachment; filename=XYZ.xlsx",
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const temp = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = temp;
          link.setAttribute("download", "file.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    callModalFromTable(item) {
    //  this.selectedUser = userId;
       this.$axios.get(`CalibrationLabSurvey/GetQuestionSurvey?orderNumber=${item.orderNumber}`).then(response=>{
      //  this.$axios.get(`${this.apiRoute}/${item.}`).then((response) => {
        this.itemsQuestion=response.data.data;
        this.showModal = true;
      })
    },
    loadItems() {
        this.$axios.get(`${this.apiRoute}/${this.currentPage}/${this.pageSize}`).then((response) => {
        this.status = false;
        this.items = response.data.data;
       
      });
    },
    showModalFunction() {
        this.showModal = true;
       this.$axios.get("CalibrationLabQuestionSurvey").then((res) => {
        //this.$axios.get(`${this.apiRoute}/${item.id}`).then((response) => {
        this.itemsQuestion = res.data.data;
       //this.showModal = true;
       });
        setTimeout(() => {
          document
            .getElementById("blogModal___BV_modal_content_")
            .removeAttribute("tabindex");
        });
      },
    }
  };
  </script>
  <style></style>
  